import React, { useState } from 'react';

const CopyToClipboardButton = ({ textToBeCopied, successText="Copied!", timeOut=1500 }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(textToBeCopied);
            setCopied(true);
            setTimeout(() => setCopied(false), timeOut);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <button style={{ paddingLeft: "6px" }} onClick={copyToClipboard}>
            {copied ? <span style={{ backgroundColor: "#E9E9E9"}}>{successText}</span> : <i className="far fa-clipboard"></i>}
        </button>
    );
};

export default CopyToClipboardButton;